import { tv } from "@/utils/tv.config";
import type { VariantProps } from "tailwind-variants";

export const calenderClasses = tv({
  slots: {
    root: ["Calender__root", "relative"],
    picker: [
      "Calender__picker",
      "w-full max-w-fit shadow-md rounded-lg bg-white border p-4",
    ],
    dayButton: [
      "Day__button",
      "hover:bg-gray-100",
      "rounded-full",
      "transition-colors",
      "text-sm",
      "disabled:cursor-not-allowed",
      "disabled:opacity-50",
    ],
  },
  variants: {
    isToday: {
      true: {
        dayButton: ["font-semi-bold text-primary-main"],
      },
    },
    isOutside: {
      true: {
        dayButton: ["text-gray-400"],
      },
    },
    isSelected: {
      true: {
        dayButton: ["bg-primary-main text-white hover:!bg-primary-dark"],
      },
    },

    size: {
      small: {
        dayButton: ["size-8"],
      },
      medium: {
        dayButton: ["size-10"],
      },
      large: {
        dayButton: ["size-12"],
      },
    },
  },
  defaultVariants: {
    size: "medium",
  },
});

export const {
  root: calenderRootClasses,
  picker: calenderPickerClasses,
  dayButton: dayButtonClasses,
} = calenderClasses();

export type CalenderVariantProps = VariantProps<typeof calenderClasses>;
